import { ContentCopy, TrendingUp } from '@mui/icons-material';
import { ActionMenu } from '@side/pantry';
import { useRouter } from 'next/router';
import { useSafeInteractionParams } from '@/common/hooks/useSafeInteractionParams';
import { TrackDocumentsEvent } from '$analytics/useTrackAnalytics/domains/documents/events';
import { useTrackDocsAnalytics } from '$analytics/useTrackAnalytics/domains/documents/useTrackDocsAnalytics';

export interface Props {
  link: string;
  label: string;
  shortUrlId: string;
}

export const PackageLinkPopupMenu = ({ link, label, shortUrlId }: Props) => {
  const { push } = useRouter();
  const trackEvent = useTrackDocsAnalytics();
  const { interactionId } = useSafeInteractionParams();

  const menuOptions = [
    {
      label: 'Copy Link',
      icon: <ContentCopy fontSize="small" />,
      onClick: () => {
        void navigator.clipboard.writeText(link);
        trackEvent(TrackDocumentsEvent.CopyLinkViewOfferModal, {
          offer_type: label === 'Offer Package' ? 'combined' : 'separate',
        });
      },
    },
    {
      label: 'Statistics',
      icon: <TrendingUp fontSize="small" />,
      onClick: async () => {
        await push({
          pathname: '/offers/[offerId]/statistics/[shortUrlId]',
          query: { offerId: interactionId, shortUrlId },
        });
        trackEvent(TrackDocumentsEvent.NavigateToStatsPageViewOfferModal, {
          offer_type: label === 'Offer Package' ? 'combined' : 'separate',
          offer_package: label,
          short_url_id: shortUrlId,
        });
      },
    },
  ];

  return (
    <ActionMenu
      title="Offer Package Options"
      options={menuOptions}
      variant="borderless"
      sx={{ mx: 1.5, my: 0.5 }}
    />
  );
};
